import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import DeliveryModal from "@/app/core/layouts/main-components/delivery/DeliveryModal";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import Functions from "@/app/core/util/Functions";
import { CurrencyConverterByCode } from "@/app/core/util/helpers/MoneyHelper";

export default function MyDeliveries() {
    const userData = Storage.getUserData();
    const [data, setData] = useState([]);
    const [international, setInternational] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [deliveryId, setDeliveryId] = useState("");
    const date = new Date();
    const [startDate, setStartDate] = useState(
        getFirstDayOfMonth(date.getFullYear(), date.getMonth())
            .toISOString()
            .substring(0, 10)
    );
    const [endDate, setEndDate] = useState(
        getFirstDayOfMonth(date.getFullYear(), date.getMonth() + 1)
            .toISOString()
            .substring(0, 10)
    );

    useEffect(() => {
        loadDeliveries()
    }, [startDate, endDate]);

    function getFirstDayOfMonth(year, month) {
        return new Date(year, month, 1);
    }

    function loadDeliveries() {
        DeliveryController.Filter(userData.id, startDate, endDate, res => {
            setData(res.filter(x => x.origin.country == "BR" && x.destination.country == "BR"));
            setInternational(res.filter(x => x.origin.country != "BR" || x.destination.country != "BR"));
        });
    }

    function openDelivery(item) {
        setDeliveryId(item.id);
        setShowModal(true);
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12" onClick={() => Functions.GoHome()}>
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.MyDeliveries)}</h3>
            </div>
            <div className="block block-fx-pop block-rounded col-12 row p-2">

                {/* <div className="form-group col-md-6">
                    <span>Pesquisar</span>
                    <input
                    type="text"
                    className="form-control form-control-alt"
                    placeholder="Pesquisar..."
                    onChange={(evt) => handleChange(evt.target.value)}
                    />
                </div> */}
                <div className="form-group col-md-6">
                    <span>{Translate(Message.StartDate)}</span>
                    <input
                        type="date"
                        className="form-control form-control-alt"
                        value={startDate}
                        onChange={(evt) => setStartDate(evt.target.value)}
                    />
                </div>
                <div className="form-group col-md-6">
                    <span>{Translate(Message.EndDate)}</span>
                    <input
                        type="date"
                        className="form-control form-control-alt"
                        value={endDate}
                        onChange={(evt) => setEndDate(evt.target.value)}
                    />
                </div>
            </div>
            <Tabs>
                <div className="block block-fx-pop block-rounded col-12">
                    <Tab><button className="btn btn-dual"><i className="si si-map mr-2"></i> ({data.length}) {Translate(Message.NationalDelivery)}</button></Tab>
                    <Tab><button className="btn btn-dual"><i className="si si-globe-alt mr-2"></i> ({international.length}) {Translate(Message.InternationalDelivery)}</button></Tab>
                </div>
                <Panel>
                    <div className="col-12">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>{Translate(Message.DeliveryCode)}</th>
                                    <th>{Translate(Message.Origin)}</th>
                                    <th>{Translate(Message.Destination)}</th>
                                    <th>Status</th>
                                    <th>{Translate(Message.RequestDate)}</th>
                                    {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map(item => (
                                    <tr>
                                        <td>{item && item.awb != undefined && item.awb != null && item.awb != "" ? item.awb : item.id}</td>
                                        <td>
                                            <span>
                                                <b>{item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood}`}</b>
                                                <br />
                                                <small>{item && item.origin && `${item.origin.city} - ${item.origin.state}`}</small>
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                <b>{item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood}`}</b>
                                                <br />
                                                <small>{item && item.destination && `${item.destination.city} - ${item.destination.state}`}</small>
                                            </span>
                                        </td>
                                        <td>{DeliveryHelper().Status(item.status)}</td>
                                        <td>{DateTranslate(item.createdAt)}</td>
                                        <td>
                                            <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Panel>
                <Panel>
                    <div className="col-12">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Key</th>
                                    <th>{Translate(Message.References)}</th>
                                    <th>{Translate(Message.DeliveryCode)}</th>
                                    <th>{Translate(Message.Origin)}</th>
                                    <th>{Translate(Message.Destination)}</th>
                                    <th>{Translate(Message.CountryOrigin)}</th>
                                    <th>{Translate(Message.CountryDestination)}</th>
                                    {userData && userData.role > 0 ?
                                        <th>{Translate(Message.Cost)}</th>
                                        : ""}
                                    <th>{Translate(Message.Value)}</th>
                                    <th>{Translate(Message.Weigth)}</th>
                                    <th>Status</th>
                                    <th>{Translate(Message.RequestDate)}</th>
                                    {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {international && international.map(item => (
                                    <tr>
                                        <td>{item && item.id}</td>
                                        <td>
                                            {item && item.origin.references ? <div>{item.origin.references}</div> : ""}
                                            {item && item.origin.references ? <div>{item.destination.references}</div> : ""}
                                        </td>
                                        <td>{item && item.awb != undefined && item.awb != null && item.awb != "" ? item.awb : item.id}</td>
                                        <td><b>{item && item.origin && item.origin.name}</b></td>
                                        <td><b>{item && item.destination && item.destination.name}</b></td>
                                        <td>{item && item.origin && item.origin.country}</td>
                                        <td>{item && item.destination && item.destination.country}</td>
                                        {userData && userData.role > 0 ?
                                            <td>{item && CurrencyConverterByCode(item.currency)}{item.operationCost && item.operationCost.toFixed(2)}</td>
                                            : ""
                                        }
                                        <td>{item && CurrencyConverterByCode(item.currency)}{item.totalPrice && item.totalPrice.toFixed(2)}</td>
                                        <td>{DeliveryHelper().Weigth(item)}Kg</td>
                                        <td>{DeliveryHelper().Status(item.status)}</td>
                                        <td>{DateTranslate(item.createdAt)}</td>
                                        <td>
                                            <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Panel>
            </Tabs>
            <DeliveryModal
                show={showModal}
                deliveryId={deliveryId}
                onHide={() => setShowModal(false)}
            />
        </div>
    )
}